import { Component, Input } from '@angular/core';

@Component({
    selector: 'cms-radio-select-option',
    templateUrl: './cms-radio-select-option.component.html',
    standalone: false,
})
export class CmsRadioSelectOptionComponent {
    @Input() selected = false;
    @Input() label = '';
}
